import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  const navigateBack = async () => {
    navigate('/');
  };

  return (
    <Result
      status='403'
      title='403'
      subTitle='Sorry, you are not authorized to access this page.'
      extra={
        <Button type='primary' onClick={navigateBack}>
          Back Home
        </Button>
      }
    />
  );
};

export default Unauthorized;
